'use es6';

import { ORDER_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Order = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('orders-read'),
  objectTypeId: ORDER_TYPE_ID,
  referenceObjectType: 'ORDER_PROPERTIES'
});
export default Order;